/**
 * Cohort Data Model (Firestore: cohorts)
 * One startup per document. Logo is resolved locally via {startupName}_Logo.png in assets/logos.
 * Fields: cohortId (number, for ordering), startupName, founderNames, status (Active|Inactive),
 * email, semester (e.g. SP26 for Spring 2026).
 */
export class Cohort {
  constructor(data) {
    this.id = data.id || null;
    this.cohortId = data.cohortId || null;
    this.startupName = data.startupName || '';
    this.founderNames = data.founderNames || '';
    this.status = data.status || 'Inactive';
    this.email = data.email || '';
    this.semester = data.semester || ''; // e.g. SP26
  }

  static fromFirestore(doc) {
    const data = doc.data();
    return new Cohort({
      id: doc.id,
      ...data,
    });
  }

  toFirestore() {
    return {
      cohortId: this.cohortId,
      startupName: this.startupName,
      founderNames: this.founderNames,
      status: this.status,
      email: this.email,
      semester: this.semester,
    };
  }

  isActive() {
    return this.status === 'Active';
  }
}
